<template>
  <v-container class="container-pedido fill-height align-start pt-3" fluid style="background-color: #f4f7f6;">
    
    <v-row class="header-fixo elevation-2 flex-column align-center px-4 py-2">
      <div class="d-flex justify-center w-100 mb-2">
        <v-btn
          class="buton-add"
          color="primary"
          @click="onClickNovo"
        >
          <v-icon left>mdi-plus</v-icon>
          Adicionar
        </v-btn>
      </div>

      <div class="d-flex justify-center align-center">
        <v-btn
          :color="filtroVendedor === 'todos' ? 'primary' : 'white'"
          :class="filtroVendedor === 'todos' ? 'white--text' : 'black--text'"
          small
          elevation="1"
          class="mr-3 px-4 font-weight-bold"
          @click="filtroVendedor = 'todos'"
        >
          <v-icon left small>mdi-format-list-bulleted</v-icon>
          Todos
        </v-btn>

        <v-btn
          :color="filtroVendedor === 'vendedor' ? 'primary' : 'white'"
          :class="filtroVendedor === 'vendedor' ? 'white--text' : 'black--text'"
          small
          elevation="1"
          class="px-4 font-weight-bold"
          @click="filtroVendedor = 'vendedor'"
        >
          <v-icon left small>mdi-account-outline</v-icon>
          Vendedor
        </v-btn>
      </div>
    </v-row>

    <v-row class="lista-com-padding">

      <v-col
        v-for="pedido in listaFiltrada"
        :key="pedido.numero"
        cols="12"
        class="mb-3">
        <v-card class="mx-4 card">
          <div 
            class="card__consumidor" 
            :class="{ 'card__consumidor--encerrada': pedido.status === 'Encerradas' }"
            style="cursor: pointer;"
            @click="pedido.showItems = !pedido.showItems"
            v-ripple
          >
            <div class="d-flex justify-space-between align-center">
              
              <div class="d-flex flex-column flex-grow-1 mr-3">
                <b>
                  {{ pedido.prsidcliente }} - 
                  <span v-if="pedido.prsnomecliente">{{ pedido.prsnomecliente }}</span>
                  <span v-else>CONSUMIDOR DIVERSOS</span>
                </b>
                
                <div class="d-flex justify-space-between align-end mt-1 w-100" style="font-size: 0.85rem; opacity: 0.95;">
  
                  <div class="d-flex flex-column">
                    <span v-if="pedido.data" class="d-flex align-center mb-1">
                      Data O.S.: {{ FormataDataGeral(pedido.data) }}
                    </span>
                    <span v-if="pedido.prsdataenviada" class="d-flex align-center mb-1">
                      Data Transmissão: {{ FormataDataGeral(pedido.prsdataenviada) }}
                    </span>

                  </div>

                  <span v-if="pedido.total !== null && pedido.total !== undefined" class="d-flex align-center ml-3">
                    <v-icon size="14" color="white" class="mr-1">mdi-cash</v-icon>
                    <b style="font-size: 0.95rem;">{{ formatarValor(pedido.total) }}</b>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <v-expand-transition>
            <div v-if="pedido.showItems">
              
              <div class="card__detalhe py-3">
                <div class="card__detalhe__icone-wrapper">
                  <v-icon class="card__detalhe__icone" size="60">
                    mdi-account-details
                  </v-icon>
                </div>
                
                <span class="card__detalhe-conteudo">
                  <template v-if="pedido.numeroExibicao">
                    <div class="d-flex justify-space-between my-1">
                      <span class="font-weight-medium">
                        Nº Ordem Serviço:
                      </span>
                      <b class="">{{ pedido.numeroExibicao }}</b>
                    </div>
                    <v-divider></v-divider>
                  </template>
                  
                  <template v-if="pedido.tecnicoverificacao">
                    <div class="d-flex justify-space-between my-1">
                      <span class="font-weight-medium">Técnico Verificação: </span>
                      <b class="">{{ pedido.tecnicoverificacao }}</b>
                    </div>
                    <v-divider></v-divider>
                  </template>
                  
                  <template v-if="pedido.defeito">
                    <div class="d-flex justify-space-between my-1">
                      <span class="font-weight-medium">Defeito: </span>
                      <b class="">{{ pedido.defeito }}</b>
                    </div>
                    <v-divider></v-divider>
                  </template>
                  
                  <template v-if="pedido.observacao">
                    <div class="d-flex justify-space-between my-1">
                      <span class="font-weight-medium">Observação: </span>
                      <b class="">{{ pedido.observacao }}</b>
                    </div>
                    <v-divider></v-divider>
                  </template>

                  <template v-if="pedido.numSerie">
                    <div class="d-flex justify-space-between my-1">
                      <span class="font-weight-medium">Nº de Série: </span>
                      <b class="">{{ pedido.numSerie }}</b>
                    </div>
                    <v-divider></v-divider>
                  </template>
                </span>
              </div>

              <div class="lighten-4 px-4 pb-3 pt-1" style="background-color: #f9f9f9;">
                <v-divider class="mb-2"></v-divider>
                <div class="text-subtitle-2 mb-2">Itens do Pedido:</div>
                
                <simplebar 
                  v-if="pedido.itens && pedido.itens.length > 0" 
                  class="table-scroll-container" 
                  data-simplebar-auto-hide="false"
                >
                  <div 
                    v-for="(item, index) in pedido.itens" 
                    :key="index"
                    class="mb-2 pb-2"
                    style="border-bottom: 1px dashed #e9e9e9;"
                  >
                    <div class="text-body-2 font-weight-medium mb-1 text-truncate">
                      {{ item.idcortamanhofinal + ' - ' + item.descricao }}
                    </div>

                    <div class="d-flex justify-space-between align-center">
                      <span class="caption grey--text text--darken-2">
                        {{ item.quantidade }} x {{ formatarValor(item.valorliquido) }}
                      </span>
                      <span class="font-weight-bold body-2 green--text text--darken-3">
                        {{ formatarValor(item.quantidade * item.valorliquido) }}
                      </span>
                    </div>
                  </div>
                </simplebar>

                <div v-if="!pedido.itens || pedido.itens.length === 0" class="text-center caption pa-2">
                  Nenhum item no pedido.
                </div>

                <div class="d-flex align-center mt-3 pt-3" style="border-top: 1px solid #e0e0e0;">
                  
                  <v-btn
                    v-if="pedido.status !== 'Encerradas' && (!pedido.prsidnuvem || pedido.prsidnuvem === 'null')"
                    color="error"
                    icon
                    @click.stop="deletarPedido(pedido)"
                    title="Deletar pedido"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>

                  <v-spacer></v-spacer>
                  
                  <v-btn 
                    :color="pedido.status === 'Encerradas' ? 'success' : 'primary'" 
                    outlined
                    :class="{'mr-3': pedido.status !== 'Encerradas'}"
                    @click.stop="abrirOuVisualizarPedido(pedido)" 
                  >
                    <v-icon left size="20">{{ pedido.status === 'Encerradas' ? 'mdi-eye' : 'mdi-pencil' }}</v-icon>
                    {{ pedido.status === 'Encerradas' ? 'Visualizar' : 'Editar' }}
                  </v-btn>

                  <v-btn
                    v-if="pedido.status !== 'Encerradas'"
                    color="primary"
                    elevation="2"
                    @click.stop="encerrarPedido(pedido)"
                  >
                    <v-icon left size="20">mdi-check-circle</v-icon>
                    Enviar
                  </v-btn>

                </div>
              </div>

            </div>
          </v-expand-transition>
        </v-card>
      </v-col>
    </v-row>  

    <BottomSheetHandler
      :aberto.sync="encerrarSheet"
      tipo="encerrar"
      :dados="pedidoSelecionado"
      @confirmar="confirmarEncerrar"
    />

    <BottomSheetHandler
      :aberto.sync="deletarSheet"
      tipo="delete"
      :dados="pedidoSelecionado"
      @confirmar="confirmarDeletar"
    />

    <BottomSheetHandler
      :aberto.sync="erroConexaoSheet"
      tipo="erro_conexao"
    />

    <!-- Dialog Visualizar -->
    <v-dialog v-model="visualizarPedidoDialog" max-width="700px">
      <v-card class="rounded-xl">
        <v-card-title class="headline d-flex justify-space-between align-center px-6 pt-5 pb-3">
          <div class="d-flex align-center">
            <v-icon color="#4c6faf" class="mr-3">mdi-text-box-search-outline</v-icon>
            <span class="font-weight-bold" style="color: #4c6faf; font-size: 1.25rem;">Detalhes da Ordem de Serviço</span>
          </div>
          <v-btn icon color="grey darken-1" @click="visualizarPedidoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="px-6 pt-2 pb-4">
          <div v-if="pedidoSelecionadoVisualizacao">
            <div class="rounded-lg grey lighten-4 pa-4 mb-6">
              <div 
                v-for="(detalhe, index) in pedidoDetalhes" 
                :key="detalhe.label" 
                class="d-flex justify-space-between mb-2"
                :class="{'mb-0': index === pedidoDetalhes.length - 1}"
              >
                <span class="text-body-2 grey--text text--darken-2 font-weight-medium">{{ detalhe.label }}:</span>
                <span class="text-body-2 font-weight-bold black--text text-right" style="white-space: pre-line;">
                  {{ detalhe.value }}
                </span>
              </div>
            </div>
            
            <div class="d-flex justify-space-between align-center mb-3">
              <div class="d-flex align-center">
                <v-icon small color="grey darken-1" class="mr-2">mdi-format-list-bulleted</v-icon>
                <span class="font-weight-bold text-subtitle-1 grey--text text--darken-3">Itens do Pedido</span>
              </div>
              <v-btn
                v-if="imagensDoPedido && imagensDoPedido.length > 0"
                color="blue darken-2"
                text
                small
                class="font-weight-bold px-2"
                @click="visualizarImagensSheet = true"
              >
                <v-icon left small>mdi-camera-outline</v-icon>
                Ver Mídias ({{ imagensDoPedido.length }})
              </v-btn>
            </div>

            <v-card outlined class="rounded-lg">
              <simplebar data-simplebar :autoHide="false">
                <v-simple-table style="min-width: 600px;">
                  <template v-slot:default>
                    <thead>
                      <tr class="primary" color="">
                        <th class="text-left font-weight-bold white--text text--darken-3">Cód. Int.</th>
                        <th class="text-left font-weight-bold white--text text--darken-3">Produto (Descrição)</th>
                        <th class="text-center font-weight-bold white--text text--darken-3">Qtd</th>
                        <th class="text-left font-weight-bold white--text text--darken-3">Observação</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in itensDoPedido" :key="item.id">
                        <td class="text-center font-weight-medium text-body-2">{{ item.produto.procodigointerno }}</td>
                        <td class="text-body-2">{{ item.produto.prodescricao }}</td>
                        <td class="text-center">
                          <v-chip small color="blue lighten-5" text-color="blue darken-2" class="font-weight-bold">
                            {{ item.quantidade }}
                          </v-chip>
                        </td>
                        <td :style="{whiteSpace: 'pre-line'}" class="text-caption grey--text text--darken-2">
                          {{ item.observacao ? item.observacao : '-'}}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </simplebar>
            </v-card>
          </div>
        </v-card-text>
        
        <v-card-actions class="px-6 pb-6 pt-0 justify-end">

          <v-btn 
            color="grey darken-1" 
            text 
            class="text-capitalize font-weight-medium px-4" 
            @click="visualizarPedidoDialog = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-bottom-sheet v-model="visualizarImagensSheet" content-class="rounded-t-lg">
      <v-card>
        <v-toolbar color="primary" dark dense flat>
          <v-toolbar-title class="font-weight-medium text-body-1">
            Mídias da O.S.
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="visualizarImagensSheet = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4">
          <div>
            <p v-if="!imagensDoPedido || imagensDoPedido.length === 0" class="text-center my-4">Nenhuma imagem encontrada para esta O.S.</p>
            <div v-else style="max-height: 250px; overflow-y: auto; overflow-x: hidden;">
            <v-row dense>
              <v-col v-for="(i, index) in imagensDoPedido" :key="index" class="d-flex child-flex" cols="4" sm="3" md="2">
                <v-card @click="abrirMidiaModal(index)" flat hover class="d-flex align-center justify-center rounded-lg">
                  <v-img v-if="i.tipo !== 'video'" :src="i.dados" aspect-ratio="1" class="grey lighten-2">
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                    <div v-else style="position: relative; height: 100%; width: 100%;">
                      <video class="imagem-preview" style="width: 100%; height: 100%; object-fit: cover;">
                        <source :src="i.dados" type="video/mp4" />
                      </video>
                      <div
                        class="d-flex align-center justify-center"
                        style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.3);"
                      >
                        <v-icon color="white" size="48">
                          mdi-play-circle-outline
                        </v-icon>
                      </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
          </div>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>

    <v-dialog v-model="midiaModalAberto" fullscreen hide-overlay transition="slide-y-reverse-transition">
      <v-card style="height: 100%; background-color: #000;">
        <v-card-text class="d-flex flex-column justify-center align-center" style="height: 100%; position: relative;">
          
          <v-btn 
            icon 
            large 
            color="white"
            style="position: absolute; top: 16px; right: 16px; z-index: 10;"
            @click="fecharMidiaModal"
          >
            <v-icon large>mdi-close</v-icon>
          </v-btn>

          <img 
            v-if="midiaModal && midiaModal.tipo === 'image'"
            :src="midiaModal.dados" 
            class="midia-fullscreen"
            style="max-width: 90%; max-height: 90%; object-fit: contain;"
          >

          <video 
            v-else-if="midiaModal && midiaModal.tipo === 'video'"
            ref="videoFullscreen"
            controls
            class="midia-fullscreen"
            style="max-width: 90%; max-height: 90%; object-fit: contain;"
          >
            <source :src="midiaModal.dados" type="video/mp4">
          </video>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-overlay :value="isSalvando" z-index="9999">
      <div class="text-center">
        <v-progress-circular indeterminate size="64" color="white"></v-progress-circular>
        <div class="mt-4 font-weight-bold white--text" style="font-size: 1.2rem;">Transmitindo O.S...</div>
      </div>
    </v-overlay>

  </v-container>
</template>

<script>
import moment from 'moment';
import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';
import db from '@/plugins/dexie'; 
import { PRESTACAO_QUERIES } from '@/constants/QUERY_FILTERS';

import $_enviaPrestacaoServico from '@/utils/local/enviaCadastro';
import BottomSheetHandler from '@/components/prestacao_servico/BottomSheetHandler.vue';
import { testarConexaoApi } from '@/utils/isonline';
import geraData from '@/utils/geradata';

export default {
  name: 'IndexView',

  components: {
    simplebar,
    BottomSheetHandler
  },
  
  data() {
    return {
      pedidos: [],
      filtroVendedor: 'todos',
      paridvendedorlogado: null,
      deletarSheet: false,
      encerrarSheet: false,
      erroConexaoSheet: false,
      pedidoSelecionado: null,

      visualizarPedidoDialog: false,
      pedidoSelecionadoVisualizacao: null,
      itensDoPedido: [],
      imagensDoPedido: [],
      visualizarImagensSheet: false,

      midiaModalAberto: false,
      midiaModal: null,
      indiceMidiaModal: null,
      isSalvando: false,
    }
  },

  computed: {
    pedidoDetalhes() {
      if (!this.pedidoSelecionadoVisualizacao) return [];
      const o = this.pedidoSelecionadoVisualizacao;
      const detalhes = [
        { label: 'Cliente', value: o.clinome },
        { label: 'Data Cadastro', value: this.FormataDataGeral(o.data) },
        { label: 'Nº Pedido', value: o.numeroExibicao },
        { label: 'Valor Total', value: this.formatarValor(o.total) },
      ];
      if (o.tecnicoverificacao) {
        detalhes.push({ label: 'Técnico Verificação', value: o.tecnicoverificacao });
      }
      if (o.observacao) {
        detalhes.push({ label: 'Observação', value: o.observacao });
      }
      if (o.numSerie) {
        detalhes.push({ label: 'Nº de Série', value: o.numSerie });
      }
      if (o.prsdataenviada) {
        detalhes.push({ label: 'Encerrado em', value: this.FormataDataGeral(o.prsdataenviada) });
      }
      return detalhes;
    },

    listaFiltrada() {
      const query = this.$route.query;
      let resultado = this.pedidos.filter(p => !p.prsdatafechamento);

      const keyFrom = PRESTACAO_QUERIES.createdFrom;
      if (query[keyFrom]) {
        const dataInicio = moment(query[keyFrom]).startOf('day');
        resultado = resultado.filter(p => {
          if (!p.data) return true;
          const mData = moment(p.data);
          if (!mData.isValid()) return true;
          return mData.isSameOrAfter(dataInicio);
        });
      }

      const keyBefore = PRESTACAO_QUERIES.createdBefore;
      if (query[keyBefore]) {
        const dataFim = moment(query[keyBefore]).endOf('day');
        resultado = resultado.filter(p => {
          if (!p.data) return true;
          const mData = moment(p.data);
          if (!mData.isValid()) return true;
          return mData.isSameOrBefore(dataFim);
        });
      }

      const keyCliente = PRESTACAO_QUERIES.codigocliente;
      if (query[keyCliente] && query[keyCliente] !== 'null') {
        const codQuery = String(query[keyCliente]);
        resultado = resultado.filter(p => 
          String(p.clienteCodigo) === codQuery || 
          String(p.prsidcliente) === codQuery
        );
      }

      if (query.status && query.status !== 'Todas') {
        resultado = resultado.filter(p => {
          const statusLocal = p.status || p.descricaostatus || ''; 
          return statusLocal.toUpperCase() === query.status.toUpperCase();
        });
      }

      if (this.filtroVendedor === 'vendedor' && this.paridvendedorlogado !== null && this.paridvendedorlogado !== undefined && this.paridvendedorlogado !== '') {
        const idLogadoStr = String(this.paridvendedorlogado);
        resultado = resultado.filter(p => {
          const vendedorId = (p.prsidtecnicoverificacao !== undefined && p.prsidtecnicoverificacao !== null && p.prsidtecnicoverificacao !== '')
            ? p.prsidtecnicoverificacao
            : ((p.prsidvendedor !== undefined && p.prsidvendedor !== null && p.prsidvendedor !== '') ? p.prsidvendedor : p.prsrecebidopor);

          return vendedorId !== undefined && vendedorId !== null && vendedorId !== '' && String(vendedorId) === idLogadoStr;
        });
      }

      return resultado;
    }
  },

  watch: {
    '$route.query': {
      deep: true,
      handler() {
        this.salvarFiltrosStorage();
      }
    },
    filtroVendedor() {
      this.salvarFiltrosStorage();
    }
  },

  async mounted() {
    const keyFrom = PRESTACAO_QUERIES.createdFrom;
    const keyBefore = PRESTACAO_QUERIES.createdBefore;
    const keyCliente = PRESTACAO_QUERIES.codigocliente;

    let savedFilters = null;
    try {
      const raw = sessionStorage.getItem('prestacaoservico:filters');
      if (raw) savedFilters = JSON.parse(raw);
    } catch (e) {
      console.error('Erro ao ler filtros do sessionStorage:', e);
    }

    if (savedFilters && savedFilters.filtroVendedor) {
      this.filtroVendedor = savedFilters.filtroVendedor;
    }

    const hasFrom = !!this.$route.query[keyFrom];
    const hasBefore = !!this.$route.query[keyBefore];

    if (!hasFrom || !hasBefore) {
      const dataAtual = new Date();
      const ano = dataAtual.getFullYear();
      const mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
      const dia = String(dataAtual.getDate()).padStart(2, '0');
      const dataHoje = `${ano}-${mes}-${dia}`;

      const queryPadrao = { ...this.$route.query };

      if (!queryPadrao[keyFrom]) {
        queryPadrao[keyFrom] = (savedFilters && savedFilters[keyFrom]) ? savedFilters[keyFrom] : dataHoje;
      }
      if (!queryPadrao[keyBefore]) {
        queryPadrao[keyBefore] = (savedFilters && savedFilters[keyBefore]) ? savedFilters[keyBefore] : dataHoje;
      }
      if (!queryPadrao[keyCliente] && savedFilters && savedFilters[keyCliente]) {
        queryPadrao[keyCliente] = savedFilters[keyCliente];
      }
      if (!queryPadrao.status) {
        queryPadrao.status = (savedFilters && savedFilters.status) ? savedFilters.status : 'Abertas';
      }

      this.$router.replace({ query: queryPadrao }).catch(() => {});
    } else {
      this.salvarFiltrosStorage();
    }

    await this.carregarPedidos();
  },

  methods: {
    salvarFiltrosStorage() {
      const keyFrom = PRESTACAO_QUERIES.createdFrom;
      const keyBefore = PRESTACAO_QUERIES.createdBefore;
      const keyCliente = PRESTACAO_QUERIES.codigocliente;
      const query = this.$route.query;

      if (!query[keyFrom] && !query[keyBefore] && !query.status) {
        return;
      }

      const filtersToSave = {
        [keyFrom]: query[keyFrom] || null,
        [keyBefore]: query[keyBefore] || null,
        [keyCliente]: query[keyCliente] || null,
        status: query.status || 'Abertas',
        filtroVendedor: this.filtroVendedor || 'todos'
      };

      sessionStorage.setItem('prestacaoservico:filters', JSON.stringify(filtersToSave));
    },
    async carregarPedidos() {
      try {
        const param = await db.parametro.toCollection().first();
        this.paridvendedorlogado = param ? param.paridvendedorlogado : null;

        const osList = (await db.prestacaoservico.toArray()).filter(os => {
          const tipoStr = String(os.prstipo ?? 1);
          return tipoStr === '1';
        });
        const itemsList = await db.prestacaoservicoitem.toArray();
        const clientesList = await db.cliente.toArray();
        const vendedoresList = await db.vendedor.toArray();

        const getNomeVendedor = (id) => {
          if (id === undefined || id === null || id === '') return '';
          const idStr = String(id);
          const idNum = Number(id);
          const vend = vendedoresList.find(v => 
            String(v.vencodigo) === idStr || 
            String(v.venidnuvem) === idStr || 
            String(v.id) === idStr ||
            (!isNaN(idNum) && (v.vencodigo === idNum || v.venidnuvem === idNum || v.id === idNum))
          );
          return vend ? (vend.vennome || vend.nome || vend.descricao) : idStr;
        };

        this.pedidos = osList.map(os => {
          
          const linkDaOs = os.prslinkpedidoitem || os.id;
          const itensDestaOs = itemsList.filter(i => 
            i.prilinkpedidoitem === linkDaOs || 
            i.idprestacaoservico === os.id ||
            (os.prsidnuvem && i.priidprestacaoserviconuvem && String(i.priidprestacaoserviconuvem) === String(os.prsidnuvem))
          );

          const itensFormatados = itensDestaOs.map(item => ({
            idcortamanhofinal: item.priidproduto,
            descricao: item.pridescricao || `Produto Cód. ${item.priidproduto}`,
            quantidade: parseFloat(item.priquantidade) || 1,
            valorliquido: parseFloat(item.privalor) || 0
          }));

          const totalCalculado = itensFormatados.reduce((acc, item) => acc + (item.quantidade * item.valorliquido), 0);

          const clienteObj = os.prsidcliente ? clientesList.find(c => String(c.cliidcliente) === String(os.prsidcliente)) : null;
          const nomeDoCliente = clienteObj ? (clienteObj.clinome || clienteObj.clinomefantasia) : (os.prsnomecliente || os.nomecliente || os.nomeCliente || 'CONSUMIDOR DIVERSOS');

          const temNuvem = os.prsidnuvem && os.prsidnuvem !== 'null';
          const numExibicao = temNuvem ? os.prsidnuvem : (os.prsidprestacaoservico || os.id);
          const nomeTecnico = getNomeVendedor(os.prsidtecnicoverificacao);

          return {
            ...os,
            numero: os.id || os.prslinkpedidoitem,
            numeroExibicao: numExibicao,
            observacao: os.prsobservacao || os.observacao || '',
            defeito: os.prsdefeito || os.defeito || '',
            numSerie: os.prsnumeroserieequipamento || os.numSerie || os.numeroserie || '',
            tecnicoverificacao: nomeTecnico,
            showItems: false,
            clienteCodigo: os.prsidcliente || os.idcliente || os.cliente || '',
            clinome: nomeDoCliente,
            prsnomecliente: nomeDoCliente,
            data: os.prsdatainclusao || os.data || os.prsdataalteracao || null,
            datatransmissao: os.datatransmissao || null,
            total: os.prstotal ? parseFloat(os.prstotal) : totalCalculado,
            idtipopedidovenda: os.idtipopedido || '',
            descricaoTipo: os.descricaotipo || '',
            status: os.status || os.descricaostatus || (os.prsdataenviada ? 'Encerradas' : 'Abertas'), 
            itens: itensFormatados
          };
        });

        this.pedidos.sort((a, b) => b.numero - a.numero);

      } catch (error) {
        console.error("Erro ao carregar os cadastros:", error);
      }
    },

    async abrirOuVisualizarPedido(pedido) {
      if (pedido.status === 'Encerradas') {
        this.pedidoSelecionadoVisualizacao = pedido;
        
        const link = pedido.prslinkpedidoitem || pedido.id;
        const prsidnuvem = pedido.prsidnuvem;
        const itens = await db.prestacaoservicoitem.filter(i => 
          i.prilinkpedidoitem === link || 
          i.idprestacaoservico === pedido.id ||
          (prsidnuvem && i.priidprestacaoserviconuvem && String(i.priidprestacaoserviconuvem) === String(prsidnuvem))
        ).toArray();
        
        this.itensDoPedido = itens.map(item => ({
            ...item,
            quantidade: item.priquantidade,
            observacao: item.priobservacao,
            produto: { prodescricao: item.pridescricao || `Produto Cód. ${item.priidproduto}`, procodigointerno: item.priidproduto || 'N/A' }
        }));

        const imagensOS = await db.imagem.where('relacaoidlocal').equals(pedido.id).filter(img => img.relacao === 'prestacaoservico').toArray();
        this.imagensDoPedido = imagensOS.map(i => ({
            ...i,
            dados: URL.createObjectURL(i.blob),
            tipo: i.blob.type.split('/')[0]
        }));

        this.visualizarPedidoDialog = true;
      } else {
        this.abrirDetalhesPedido(pedido);
      }
    },

    abrirMidiaModal(index) {
      this.indiceMidiaModal = index;
      this.midiaModal = this.imagensDoPedido[index];
      this.midiaModalAberto = true;

      this.$nextTick(() => {
        if (this.$refs.videoFullscreen && this.midiaModal && this.midiaModal.tipo === 'video') {
          this.$refs.videoFullscreen.pause();
        }
      });
    },

    fecharMidiaModal() {
      if (this.$refs.videoFullscreen && this.midiaModal.tipo === 'video') {
        this.$refs.videoFullscreen.pause();
        this.$refs.videoFullscreen.currentTime = 0;
      }
      this.midiaModalAberto = false;
      this.midiaModal = null;
      this.indiceMidiaModal = null;
    },

    onClickNovo() {
      sessionStorage.removeItem('osEmEdicao');
      sessionStorage.removeItem('veiculoEmEdicao');
      sessionStorage.removeItem('pesquisaResultado');
      sessionStorage.removeItem('idPedidoVinculoAtual');
      sessionStorage.removeItem('veiculo_selecionado_retorno');
      sessionStorage.removeItem('cor_selecionada_retorno');
      sessionStorage.removeItem('marca_selecionada_retorno');

      this.$router.push({ name: 'cadastroos' });
    },

    abrirDetalhesPedido(pedido) {
      sessionStorage.setItem('osEmEdicao', JSON.stringify(pedido));
      this.$router.push({ 
        name: 'cadastroos', 
        query: { id: pedido.numero } 
      });
    },

    deletarPedido(pedido) {
      this.pedidoSelecionado = pedido;
      this.deletarSheet = true;
    },

    async confirmarDeletar() {
      if (this.pedidoSelecionado) {
        const pedidoId = this.pedidoSelecionado.id;
        const link = this.pedidoSelecionado.prslinkpedidoitem || this.pedidoSelecionado.id;
        
        try {
          const prsidnuvem = this.pedidoSelecionado.prsidnuvem;
          const itens = await db.prestacaoservicoitem.filter(i => 
            i.prilinkpedidoitem === link || 
            i.idprestacaoservico === pedidoId ||
            (prsidnuvem && i.priidprestacaoserviconuvem && String(i.priidprestacaoserviconuvem) === String(prsidnuvem))
          ).toArray();
          for (const item of itens) {
            await db.imagem.where({ relacao: 'prestacaoservicoitem', relacaoidlocal: item.id }).delete();
            await db.prestacaoservicoitem.delete(item.id);
          }
          
          await db.imagem.where({ relacao: 'prestacaoservico', relacaoidlocal: pedidoId }).delete();
          await db.prestacaoservico.delete(pedidoId);
          
          this.deletarSheet = false;
          this.pedidoSelecionado = null;
          await this.carregarPedidos();
        } catch (e) {
          console.error("Erro ao deletar:", e);
        }
      }
    },

    async encerrarPedido(pedido) {
      this.isSalvando = true;
      try {
        const conectou = await testarConexaoApi();
        if (!conectou) {
          this.erroConexaoSheet = true;
          return;
        }
        this.pedidoSelecionado = pedido;
        this.encerrarSheet = true;
      } finally {
        this.isSalvando = false;
      }
    },

    async confirmarEncerrar() {
      if (this.pedidoSelecionado) {
        this.isSalvando = true;
        try {
          const conectou = await testarConexaoApi();
          if (!conectou) {
            this.encerrarSheet = false;
            this.erroConexaoSheet = true;
            return;
          }

          const idDaOrdemServico = this.pedidoSelecionado.id;
          
          await $_enviaPrestacaoServico(idDaOrdemServico);
          
          const osAtualizada = await db.prestacaoservico.get(idDaOrdemServico);
          
          if (osAtualizada && osAtualizada.prsdatatransmissao) {
            await db.prestacaoservico.update(idDaOrdemServico, {
              status: 'Encerradas',
              descricaostatus: 'Encerradas',
              prsdataenviada: geraData()
            });
            this.encerrarSheet = false;
            this.pedidoSelecionado = null;
            await this.carregarPedidos();
          } else {
            this.encerrarSheet = false;
            this.erroConexaoSheet = true;
          }
        } catch (e) {
          console.error("Erro ao encerrar:", e);
          this.encerrarSheet = false;
          this.erroConexaoSheet = true;
        } finally {
          this.isSalvando = false;
        }
      }
    },
    
    formatarValor(valor) {
      if (valor === undefined || valor === null || isNaN(valor)) return 'R$ 0,00';
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);
    },

    FormataDataGeral(date) {
      if (!date) return '';
      return moment(date).format('DD/MM/YYYY HH:mm'); 
    },
  }
}
</script>

<style scoped>
/* O <style> permance exatamente igual */
.container-pedido{
  padding: 0;
  margin: 0;
}

.header-fixo {
  justify-content: center;
  position: fixed;
  width: 100%;
  margin: -12px 0 0 0;
  z-index: 3;
  background-color: #eeeeee; 
  padding: 12px 0 12px 0;
}

.lista-com-padding {
  padding-top: 95px;
}

.card {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.card__consumidor {
  padding: 12px 16px;
  font-size: 1.1rem;
  color: white;
  background-color: #4c6faf;
  transition: background-color 0.3s ease;
}

.card__consumidor--encerrada {
  background-color: #4caf50 !important; 
}

.card__detalhe {
  display: flex;
  align-items: center;
  padding: 0 16px 0 16px;
  flex-grow: 1;
}

.card__detalhe__icone-wrapper {
  margin-right: 16px;
}

.card__detalhe-conteudo {
  flex-grow: 1;
  font-size: 0.9rem;
}

.card__detalhe-conteudo > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.table-scroll-container {
  max-height: 165px; 
  padding-right: 10px;
}
.table-scroll-container ::v-deep .simplebar-scrollbar::before {
  background: rgba(76, 111, 175, 0.4) !important;
}

@media (min-width: 960px) {
  .header-fixo {
  justify-content: center;
  position: fixed;
  width: 80%;
  margin: 0;
  z-index: 3;
  background-color: #eeeeee; 

}
.lista-com-padding {
  justify-content: center;
  margin: auto;
  width: 80%;
  margin-top: 20px;
  padding-top: 50px;

}
.buton-add{
  padding-right: 16px;

}
}
</style>